import React from "react";
import { useLocation } from "react-router-dom";
import useWalletTransactionLog from "../../custom-hooks/useWalletTransactionLog";
import BackButtonComponent from "../../NewComponents/BackButton/BackButton.component";
import Loader from "../../NewComponents/Loader/Loader.component";
import NoTableDataAvailable from "../../NewComponents/NoTableDataAvailable/NoTableDataAvailable.component";

const WalletTransactionLog = () => {
  const location = useLocation();

  const {
    data: transactionLog,
    status,
    error,
  } = useWalletTransactionLog({
    transaction_ref: location?.state?.data?.maker_checker_reference,
  });
  return (
    <div>
      <div className="d-flex align-items-center justify-content-start">
        <h3 className="page-title d-flex align-items-center">
          <BackButtonComponent />
          Wallet Transaction Approval Log
        </h3>
      </div>
      {error && <p className="alert alert-danger small">{error}</p>}
      {!error && (
        <div className="mt-4">
          <div className="card">
            {status === "loading" ? (
              <div className="d-flex justify-content-center align-items-center">
                <Loader />
              </div>
            ) : (
              <div className="card-body p-3 mt-2">
                <div className="table-responsive">
                  <table className="table">
                    <thead className="bg-lighter-grey">
                      <tr>
                        <th>Email</th>
                        <th>Approval Comment</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactionLog?.data?.length ? (
                        transactionLog.data.map((log, _id) => {
                          const { email, approvalComment, createdAt } = log;
                          return (
                            <tr key={_id}>
                              <td>{email}</td>
                              <td>{approvalComment}</td>
                              <td>{createdAt}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <NoTableDataAvailable />
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletTransactionLog;
